import type { UseActivityLogQueryParams } from "./useActivityLogQuery";

export const ACTIVITY_LOG_QUERY_KEYS = {
  all: ["ACTIVITY_LOG"] as const,
  list: (params: UseActivityLogQueryParams) =>
    [...ACTIVITY_LOG_QUERY_KEYS.all, "LIST", params] as const,
} as const;
